export class ObjectId {
    static get() {
        var timestamp = (new Date().getTime() / 1000 | 0).toString(16);
        return timestamp + 'xxxxxxxxxxxxxxxx'.replace(/[x]/g, () => {
                return (Math.random() * 16 | 0).toString(16);
            }).toLowerCase();
    }
}




// WEBPACK FOOTER //
// ./app/assets/javascripts/services/ObjectId.ts